import React from 'react';

const MeetingControls = ({
  selectedUser,
  currentUser,
  activeMeeting,
  onStartMeeting,
  onEndMeeting,
  meetingStartTime,
  onDeselectUser
}) => {
  const formatTime = (date) => {
    if (!date) return 'N/A';
    
    try {
      const dateObj = date instanceof Date ? date : new Date(date);
      if (isNaN(dateObj.getTime())) return 'Invalid Date';
      
      return dateObj.toLocaleString("en-US", {
        timeZone: "America/New_York",
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch (error) {
      return 'Invalid Date';
    }
  };

  const canStartMeeting = !activeMeeting && selectedUser;
  const canEndMeeting = activeMeeting;

  return (
    <div className="meeting-controls-redesign">
      {activeMeeting && (
        <div className="controls-header">
            <div className="meeting-start-time">
              Started at: <span className="time-value">{formatTime(meetingStartTime)}</span>
            </div>
        </div>
      )}

      {activeMeeting ? (
        <div className="active-meeting-status">
          <div className="meeting-info">
            <div className="info-item">
              <span className="info-label">Status:</span>
              <span className="info-value active">Meeting Active</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="meeting-prompt">
          {selectedUser ? (
            <div className="ready-to-meet">
              <div className="ready-icon">✓</div>
              <div className="ready-text">
                <h3>Ready to Start Meeting</h3>
                <p>Meeting with <strong>{selectedUser.first_name}</strong> can be started</p>
                {/* ✅ Deselect button */}
                {onDeselectUser && (
                  <button 
                    className="deselect-link-btn"
                    onClick={onDeselectUser}
                  >
                    Remove selected user
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div className="select-prompt">
              <div className="select-icon">👤</div>
              <div className="select-text">
                <h3>Select a User</h3>
                <p>Choose a user from the list to start a meeting</p>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="control-buttons-redesign">
        <button
          className={`start-btn-redesign ${canStartMeeting ? 'enabled' : 'disabled'}`}
          onClick={onStartMeeting}
          disabled={!canStartMeeting}
        >
          <span className="btn-icon">▶</span>
          <span className="btn-text">Start Meeting</span>
        </button>

        <button
          className={`end-btn-redesign ${canEndMeeting ? 'enabled' : 'disabled'}`}
          onClick={onEndMeeting}
          disabled={!canEndMeeting}
        >
          <span className="btn-icon">⏹</span>
          <span className="btn-text">End Meeting</span>
        </button>
      </div>
    </div>
  );
};

export default MeetingControls;